import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as c from './constant';
import * as actions from './action';
import PieComponent from './components/PieComponent';
import EwalletDashboardContainer from './containers/EwalletDashboardContainer';

const DashboardContainer = ({ getTotalStats, totalStats }) => {

  const transactions = _.get(totalStats, 'e_wallet_service_transactions');

  useEffect(() => {
    getTotalStats();
  }, []);

  const formatData = (data) => {
    if (!data) return [];
    return Object.keys(data).map((val) => {
      return { name: val, value: Number(data[val]) };
    });
  };

  const renderLegends = (dt) =>
    dt.map((x) => (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    ));
  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col pl-0">

          <div className="row pie">
            <div className="col-12 pie-title text-left">Transactions</div>
            <div className="col-12 pie-wrapper ">
              <PieComponent chartData={formatData(transactions)} />
            </div>
            <div className="legends-wrapper px-3">{renderLegends(c.E_WALLET)}</div>
          </div>

        </div>
        <div className="col-8 pr-0">
          {/* TODO: change pie-title to chart-title and apply pie-title's css props later  */}
          <div className="col-12 pie-title text-left">
            <EwalletDashboardContainer />
          </div>

        </div>
      </div>
    </div>
  )
}


DashboardContainer.defaultProps = {
  totalStats: {},
};

DashboardContainer.propTypes = {
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
  totalStats: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}.res`),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DashboardContainer);
